// src/pages/user/Withdraw.tsx

import Withdraw from "../../components/user/Withdraw";

export default function WithdrawPage() {
  return <Withdraw />;
}